/**
 * Created by Jonas Wålekvist on 2018-02-22.
 */
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IDungeonQuestAdjacentBetLineWinData} from "../../utils/DungeonQuestSymbolUtil";
import {Timeline, TimelineLite} from "gsap"
import {DungeonQuestGameConfig} from "../DungeonQuestGameConfig";

export class DungeonQuestBetLineWinIndividualWPController extends BetLineWinIndividualWPController {

    constructor(config:IIndividualWinPresentationConfig, name?:string, tweakEnabled?:boolean) {
        super(config, name, tweakEnabled);
    }

    protected getLineAnimation(betLineWinData:IBetLineWinData):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, betLineWinData.betLineIndex));
        });

        let adjacentBetLineWinData:IDungeonQuestAdjacentBetLineWinData = <IDungeonQuestAdjacentBetLineWinData>betLineWinData;
        for(let i:number = 0; i < adjacentBetLineWinData.winPosition.length; i++) {
            if(adjacentBetLineWinData.winPosition[i]) {
                const symbol = Reels.getSymbol(i, betLineWinData.betLine[i]);
                if(symbol) {
                    this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, this._config.symbolTimeOffsetCalculator(timeline.totalDuration(), i, betLineWinData.betLine[i]), symbol, i, betLineWinData.betLine[i]);
                    this._winSymbols.push(symbol);
                }
            }
        }
        return timeline;
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        timeline.add(symbol.changeState({
            state : DungeonQuestGameConfig.instance.SYMBOL_STATES.winToggle,
            fadeInDuration : 0
        }), startTime);
    }
}